import { useTranslation } from 'react-i18next';

export const useGenderLabel = () => {
  const { t } = useTranslation();

  const getGenderLabel = (gender: string) => {
    const genderLabels = {
      men: t('shared.menPossessive', "men's"),
      women: t('shared.womenPossessive', "women's"),
      youth: t('shared.youthPossessive', "youth's"),
      infant: t('shared.infantPossessive', "infant's"),
    };

    return genderLabels[gender] || gender;
  };

  return getGenderLabel;
};
